// extracted by mini-css-extract-plugin
export default {"rdsrvices":"RdDesignServices_rdsrvices__01Ndk","container":"RdDesignServices_container__Ecm44"};